import type { IFooterLinkConfig } from '@/pages/dashboard/_config/constant';
import {
  LEFT_MENU_FOOTER_LINK_LIST,
  PAGE_PATH_MAP,
  PAGE_TYPE_OUT_PATH,
} from '@/pages/dashboard/_config/constant';

// 检查字符是否为空
export const checkNameNull : (val: string) => boolean = (val) => {
  if (!val) {
    return true;
  }
  return /^[ ]+$/.test(val);
};

// 检查字符格式
export const checkNameError: (val: string, type?: string) => boolean = (val, type) => {
  // 短划线
  // return  !/^[\u4E00-\u9FA5\sA-Za-z0-9_]+$/.test(val);
  // return !/^[\u4E00-\u9FA5\sA-Za-z0-9_\-]+$/.test(val);
  // 添加英文句号. 校验  如：去小号页面的英文Daily-excl.smurf
  if (type === "folder" || type === "subfolder") {
    // return !/^[\u4E00-\u9FA5\sA-Za-z0-9_\-.&()]+$/.test(val);
    return !/^[\u4E00-\u9FA5\sA-Za-z0-9_\-.&()<>：“”:"'‘’]+$/.test(val);
  }
  // 处理其他类型的情况，或者返回默认值
  // return !/^[\u4E00-\u9FA5\sA-Za-z0-9_\-.]+$/.test(val); // 或者其他逻辑
  return !/^[\u4E00-\u9FA5\sA-Za-z0-9_\-.&<>：“”:"'‘’]+$/.test(val);
};

// 解析当前路径中的page_type和value
export const findPathTypeAndValue = (path: string): { type: string; value: string; } => {
  const pathParts = path.split('/');
  if (pathParts.length === 2) {
    // 路径只有两项
    return { type: 'path', value: `/${path}` };
  }

  if (pathParts.length === 3) {
    // 路径有三项
    const key = `${pathParts[0]}/${pathParts[1]}`;
    const value = pathParts[2];
    // 查找 PAGE_PATH_MAP 中是否能匹配到对应的键
    const matchedPageType = Object.keys(PAGE_PATH_MAP).find(
      (pageType) => PAGE_PATH_MAP[pageType as keyof typeof PAGE_PATH_MAP] === key
    );
    if (matchedPageType) {
      // 如果匹配到，则处理 matchedPageType 为默认类型 tableau 的特殊情况
      const type = matchedPageType === 'default' ? 'tableau' : matchedPageType;
      return { type, value };
    }
  }

  return { type: 'path', value: `/${path}` };
};

/** 按 gameCode 从 LEFT_MENU_FOOTER_LINK_LIST 中匹配外链配置 */
export const getFooterLinkConfig = (
  gameCode?: string,
): IFooterLinkConfig | undefined => {
  if (!gameCode) {
    return undefined;
  }
  const matched = LEFT_MENU_FOOTER_LINK_LIST.find(({ gameCodes }) =>
    gameCodes.includes(gameCode),
  );
  if (!matched) {
    return undefined;
  }
  const { gameCodes, ...config } = matched;
  return config;
};

/**
 * 拼接底部外链打开地址
 * - outPath: url 原样（根路径相对地址，不含 /v2 等 base 前缀，如 /as/report/...）
 * - out_url: url 原样（完整外链）
 */
export const buildFooterLinkUrl = (config: IFooterLinkConfig): string => {
  return config.url;
};

export interface IOpenFooterLinkOptions {
  gameCode?: string;
}

/** 新窗口打开底部外链，outPath 类型导航到 authEmbed 页面由页面端获取 token */
export const openFooterLink = (
  config: IFooterLinkConfig,
  options?: IOpenFooterLinkOptions,
): void => {
  const url = buildFooterLinkUrl(config);
  if (!url) {
    return;
  }

  if (config.page_type === PAGE_TYPE_OUT_PATH && options?.gameCode) {
    const embedUrl = `/dashboard/game/${options.gameCode}/authEmbed?target=${encodeURIComponent(url)}`;
    window.open(embedUrl);
    return;
  }

  window.open(url);
};
